module.exports = __webpack_public_path__ + "img/thermometer-lines.c18deba1.png";